import { useQuery } from "@apollo/client";

import { getFragmentData } from "../../__generated__/fragment-masking";
import type { ClientProfileFieldsFragment } from "../../__generated__/graphql";
import { ClientProfileDocument, ClientProfileFieldsFragmentDoc } from "../../__generated__/graphql";
import { useClientId } from "../use-client-id";

export type ClientProfile = ClientProfileFieldsFragment;

export function useClientProfile(explicitClientId?: string): {
  client: ClientProfile | null;
  loading: boolean;
} {
  const currentClientId = useClientId();
  const clientId = explicitClientId ?? currentClientId;
  const { data, loading } = useQuery(ClientProfileDocument, {
    skip: !clientId,
    fetchPolicy: "cache-first",
    variables: { id: clientId },
  });

  const client = getFragmentData(ClientProfileFieldsFragmentDoc, data?.client);

  return { client: client ?? null, loading };
}
